<template>
  <InputText type="tel" placeholder="Telefoonnummer" v-model="userPart" @input="onInput">
    <!-- After input so it doesn't get selected -->
    <template #after-input>
      <div class="absolute inset-y-0 flex">
        <label>
          <span class="hidden">Landcode</span>
          <select
            v-model="selectedCountryCode"
            @input="onInput"
            :disabled="$attrs.disabled as boolean"
            tabindex="-1"
            class="surface focus:border-secondary focus:ring-secondary h-full rounded-md border-0 py-0 pr-7 pl-3 focus:ring-2 sm:text-sm"
          >
            <option v-for="(countryCode, index) in countryCodes" :value="countryCode" :key="index">
              {{ countryCode.text }}
            </option>
          </select>
          <span class="text-sm">{{ selectedCountryCode?.value }}</span>
        </label>
      </div>
    </template>
  </InputText>
</template>

<script setup lang="ts">
import InputText from "@/components/inputs/InputText.vue"
import { onMounted, ref, watch, type Ref } from "vue"
import { type ComboboxCountryCodeOption } from "@/interfaces/component/combobox-country-code-option.interface"

const modelValue = defineModel<string | null | undefined>({ default: undefined })

const emit = defineEmits(["input", "update:modelValue"])

const selectedCountryCode: Ref<ComboboxCountryCodeOption | null> = ref(null)
const userPart = ref("")

function onInput() {
  setTimeout(() => {
    if (userPart.value.length === 0) {
      emit("update:modelValue", null)
      emit("input")
      return
    }

    const countryCode = selectedCountryCode.value?.value || ""
    const userPrt = userPart.value || ""
    emit("update:modelValue", countryCode + userPrt)
    emit("input")
  })
}

const countryCodes: Ref<ComboboxCountryCodeOption[]> = ref([
  { text: "NL", value: "+31" },
  { text: "BE", value: "+32" },
  { text: "FR", value: "+33" },
  { text: "PL", value: "+48" },
  { text: "DE", value: "+49" },
  { text: "LU", value: "+352" }
])

// Default value
onMounted(() => {
  selectedCountryCode.value = selectedCountryCode.value = countryCodes.value[0]
})

watch(
  modelValue,
  (val) => {
    if (val) {
      const countryCodeObject = getCountryCodeObject(val)
      if (countryCodeObject) {
        selectedCountryCode.value = countryCodeObject
        userPart.value = val.slice(countryCodeObject.value.length)
      }
    } else {
      userPart.value = ""
    }
  },
  { immediate: true }
)

function getCountryCodeObject(phoneNumber: string) {
  for (const countryCode of countryCodes.value) {
    if (phoneNumber.startsWith(countryCode.value)) {
      return countryCode
    }
  }
}
</script>

<style scoped></style>
